const base = '/api';
export default {
  base,
  graphql: `${base}/graphql`,
  files: `${base}/files`,
};
